export enum TipoComponente {
  FORM = 'FORM',
  CUSTOM = 'CUSTOM',
  VUEJS = 'VUEJS',
  HTML = 'HTML',
}
